module.exports = __webpack_public_path__ + "static/media/porductos_altena__galletera.7115717d.jpg";